import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getLabel } from '../data/labels';

export default function GobackButton() {
    const navigate = useNavigate();

    return (
        <button onClick={() => navigate(-1)} className="h-10 mx-2 my-1 flex items-center justify-center bg-cs7 font-medium text-cs3 rounded">
            <i className="bi-arrow-left mr-2" />
            {getLabel('general.back')}
        </button>
    );
}
